const createBlogSchema = ({
  title,
  description,
  url,
  image,
  datePublished,
  dateModified,
  authorName = "Gurukrupa Wood Pvt. Ltd."
}) => {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "@id": `${url}#blogpost`,

    "headline": title,

    "description": description,

    "url": url,

    "image": image,

    "datePublished": datePublished,

    "dateModified": dateModified || datePublished,

    "author": {
      "@type": "Organization",
      "@id": "https://gurukrupawood.com/#organization",
      "name": "Gurukrupa Pvt. Ltd."
    },

    "publisher": {
      "@id": "https://gurukrupawood.com/#organization"
    },

    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${url}#webpage`
    }
  };
};

export default createBlogSchema;